import { resolveOriginalMessageLink } from "../../utils/mailProvider";

const TaskEmailLink = ({ link, className, children }) => {
  const resolved = resolveOriginalMessageLink(link);

  if (!resolved.isAvailable) {
    return (
      <span
        title={resolved.unavailableText}
        aria-label={resolved.unavailableText}
        className={`text-stone-400 ${className ?? ""}`.trim()}
      >
        {children}
      </span>
    );
  }

  return (
    <a
      href={resolved.href}
      target="_blank"
      rel="noopener noreferrer"
      title={resolved.label}
      aria-label={resolved.label}
      data-amp-track-section="Task Workspace"
      data-amp-track-action="External_Link_Click"
      data-amp-track-description={`Open Email in ${resolved.providerName}`}
      className={className}
    >
      {children}
    </a>
  );
};

export default TaskEmailLink;
